import { Component, inject, OnInit, OnDestroy, Inject, PLATFORM_ID, TransferState  } from '@angular/core';
import { isPlatformServer, DOCUMENT, isPlatformBrowser } from '@angular/common';
import { ActivatedRoute, ParamMap, Params, Router } from '@angular/router';
import { isEmpty, Subscription, filter } from 'rxjs';
import { distinctUntilChanged, take, debounceTime } from 'rxjs/operators';

import { CssSwitcherService } from './_services/css-switcher.service';
import { LandingPageV1Component } from './landing-pages/landing-page-v1/landing-page-v1.component';
import { MetaTagsManagementService } from './_services/meta-tags-management.service';
import { RedirectService } from './_services/redirect.service';
import { FormBrandService } from './_services/form-brand.service';
import { LandingApiProgressService } from './_services/landing-api-progress.service';
import { IPQSService } from './_services/ipqs.service'
import { WindowService } from './_services/window.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit {

  private route = inject(ActivatedRoute);
  private router = inject(Router); //Redirecting purpose
  private paramsSubscription!: Subscription;
  private subscription!: Subscription;
  private redirectService = inject(RedirectService);

  dominio: string = "";
  mutualMortgageDomain: any = [
    "mutualmortgage.com", 
    "www.mutualmortgage.com",
    "sms.mutualmortgage.com"
  ];

  
  
  currentComponent: any = LandingPageV1Component;
  componentInputs = {
    landingPageID: '',
    landingPageTypeID: ''
  };
  isLoading = true;

  landingPageConstraints: any = [
      {
        landingPageID: '3Qoh5ARmTaXrdBUqzugHsn',
        landingPageTypeID: '1',
        cssFile: 'mutualmortgage',
        acceptedDomains: [
          "mutualmortgage.com", 
          "www.mutualmortgage.com",
          "sms.mutualmortgage.com",
          
          ]
      },
      {
        landingPageID: '59j6wxNjWRqyoF5HvclHE0',
        landingPageTypeID: '1',
        acceptedDomains: [
          "marketing.federalfirstlending.com",
          "engage.federalfirstlending.com",
          ]
      },


  ];
  

  constructor(
    private cssSwitcher: CssSwitcherService,
    private metaTagsManagementService: MetaTagsManagementService,

    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(DOCUMENT) private document: Document,
    private transferState: TransferState,
    private formBrandService: FormBrandService,
    private landingApiProgressService: LandingApiProgressService,
    private IPQS: IPQSService,
    private windowService: WindowService
    
  ) {
        this.dominio = this.document.location.hostname;
    }



  ngOnInit() {    

    const pathCode = this.getPathCode();
    // this.IPQS.getIPQSQualityScore().subscribe((res) => {
    //   this.IPQS.IPQSInfo$.next(res)      
    // });
    
    // if (pathCode && pathCode.length === 6) {
    //   this.redirect(pathCode);
    //   return;
    // }


    this.route.queryParams
    .pipe(
      debounceTime(0),      
      take(1)
    )
    .subscribe(params => {      
      const landingPageID = params['landingPageID'];
      const landingPageTypeID = params['landingPageTypeID'];

      const TCPABrandID = params['TCPABrandID'];
      const DisclosID = params['DisclosID'] || params['disclosureId'] || params['disclosid'];
      const CO = params['co'];
      

      if(TCPABrandID &&  DisclosID){ 
        this.formBrandService.getFormBrandSettings(TCPABrandID, DisclosID, CO);
      }

      if (landingPageID && landingPageTypeID) {
        this.loadFormByParams(landingPageID, landingPageTypeID, params);        
      } else {
        this.loadFormByDomain();
      }
    });
  }


  private updateComponent(landingPageTypeID: string) {
    switch (landingPageTypeID) {
      case '1':
        this.currentComponent = LandingPageV1Component;
        break;
      case '2':
        this.currentComponent = LandingPageV1Component;
        break;
      default:
        this.currentComponent = LandingPageV1Component;
    }
  }
  
  private loadFormByParams(landingPageID: string, landingPageTypeID: string, params: Params) {
    this.updateComponent(landingPageTypeID);
    this.componentInputs = {
      landingPageID: landingPageID,
      landingPageTypeID: landingPageTypeID
    };  

      const cssFile = params['style'] || 'default';
      const firstName = params['FName'] || '';
      const address = params['Address'] || '';
      const imgVersion = params['ImgVersion'] || '';
      const imgResolver = params['imgResolver'] || '';

      if (imgVersion && firstName && address) {
        this.metaTagsManagementService.updateDynamicImage({
          imgVersion,
          firstName,
          address,
          imgResolver
        });
      }
       
      this.cssSwitcher.switchCss(cssFile)
      .then(success => {
        if (!success) {
          this.cssSwitcher.switchCss('default');
        }
        this.isLoading = false;
      });    

  }

  private _loadFormByDomain() {
    const domain = this.document.location.hostname;
    if (this.mutualMortgageDomain.find((d:any) => d === domain)) {
        this.componentInputs = {
        landingPageID: '3Qoh5ARmTaXrdBUqzugHsn',
        landingPageTypeID: '1'        
      }
      this.updateComponent(this.componentInputs.landingPageTypeID);
      const cssFile = "mutualmortgage";

      this.cssSwitcher.switchCss(cssFile)
      .then(success => {
        if (!success) {
          console.warn(`Loading default theme, ${cssFile}.css not found`);
          this.cssSwitcher.switchCss('default');
        }
      });
      this.isLoading = false;
    }

    
    

  }

  private loadFormByDomain(): void {
    const domain = this.document.location.hostname;
    
    const matchedConfig = this.landingPageConstraints.find(
      (config: any) => config.acceptedDomains.includes(domain)
    );

    if (matchedConfig) {      
      this.componentInputs = {
        landingPageID: matchedConfig.landingPageID,
        landingPageTypeID: matchedConfig.landingPageTypeID
      };

      this.updateComponent(this.componentInputs.landingPageTypeID);
      const cssFile = matchedConfig.cssFile || 'default';

      this.cssSwitcher.switchCss(cssFile)
        .then(success => {
          if (!success) {
            this.cssSwitcher.switchCss('default');
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    } else {
      console.warn(`Evolute: No contenful configuration found for domain: ${domain}`);
      this.cssSwitcher.switchCss('default')
        .finally(() => {
          this.isLoading = false;
        });
    }
  }


  private getPathCode(): string | null {
    const currentUrl = this.document.location.href;

    const url = new URL(currentUrl);
    const pathname = url.pathname;
    
    let cleanPath = pathname.replace(/^\/+|\/+$/g, ''); 
    
    if (cleanPath && cleanPath.length === 6 && !cleanPath.includes('/')) {
      return cleanPath;
    }
    
    return null;
  }

  private async redirect(code: string): Promise<void> {
    try {      
      // Obtener la URL larga del servicio
      const longUrl = await this.redirectService.getLongUrl(code);
      console.log("Long URL obtenida:", longUrl);
    
            
      if (longUrl) {                
        if (isPlatformBrowser(this.platformId)) {
          window.location.href = longUrl;
        }
      } else {
        console.error("No se pudo obtener la URL para el código:", code);
        this.router.navigate(['/']);
      }
    } catch (error) {
      console.error("Error en redirect:", error);
      this.router.navigate(['/']);
    }
  }

  private async prepareSaveRedirectLandingAPIProgress(step: string, longURL: string | null ): Promise<void> {
    if (!longURL) {
      return;
    }
    longURL.split('?')[1]
    const urlSearchParams = new URLSearchParams(longURL.split('?')[1]);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (params && Object.keys(params).length > 0) {
            
      var utmSourceParts = params['utm_source'] ? params['utm_source'].split('_') : [];
      var OfferID = 0;
      var ThreadID = 0;
      if(utmSourceParts.length > 1) {
        OfferID = parseInt(utmSourceParts[1], 10);
        ThreadID = parseInt(utmSourceParts[2], 10);
      }
      var jsonstr = JSON.stringify(params);

      const requestData = {
          DateAdde: new Date(),
          DropDate: params['utm_term'] || '',
          Phone: params['confirmation'] || 0,
          StepName: step,
          StepID: 0,
          RecordID: params['RecordID'] || 0,
          VerticalType: 1,
          OfferID: OfferID,
          ThreadID: ThreadID,
          jsonValue: jsonstr,
          RecordsForSMSReservedID: params['RecordsForSMSReservedAutoID'] || 0,
      };

      this.landingApiProgressService.save(requestData);
    }
  }



}  




